import { render } from "./TrainingInfo.vue?vue&type=template&id=68be968c&scoped=true"
import script from "./TrainingInfo.vue?vue&type=script&lang=js"
export * from "./TrainingInfo.vue?vue&type=script&lang=js"

import "./TrainingInfo.vue?vue&type=style&index=0&id=68be968c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68be968c"]])

export default __exports__